import {
  Component, Input,
} from '@angular/core';
import { DashboardComponentInterface } from '@models/dashboard';
import { Workflow, WorkflowService } from '@nimmsta/ng-commons-lib';
import { WorkflowDashboardConfiguration } from './workflow-dashboard-configuration';

@Component({
  selector: 'app-workflow-dashboard',
  templateUrl: './workflow-dashboard.component.html',
})
export class WorkflowDashboardComponent implements DashboardComponentInterface {
  @Input() configuration!: WorkflowDashboardConfiguration;

  protected workflows: Workflow[] = [];

  protected isLoading = false;

  constructor(
    private workflowService: WorkflowService,
  ) {}

  setConfiguration(configuration: unknown): void {
    this.configuration = { ...this.configuration, ...configuration as object };
  }

  loadData() {
    this.isLoading = true;
    this.workflowService.simpleList().subscribe((data) => {
      this.workflows = data;
      this.isLoading = false;
    });
  }
}
